import * as React from 'react';

export type UseCollapseStateResult = {
  opened: boolean;
  hasContent: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
};

const useCollapseState = (
  initialValue = false,
  delay = 200
): UseCollapseStateResult => {
  const [opened, setOpened] = React.useState(initialValue);
  const [hasContent, setHasContent] = React.useState(initialValue);
  const timeoutRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);

  React.useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const open = React.useCallback(() => {
    setHasContent(true);
    setOpened(true);
  }, []);

  const close = React.useCallback(() => {
    setOpened(false);
    // Очищаем предыдущий таймер если он есть
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    // Ждем окончания анимации закрытия перед скрытием контента
    timeoutRef.current = setTimeout(() => {
      setHasContent(false);
    }, delay);
  }, [delay]);

  const toggle = React.useCallback(() => {
    if (opened) {
      close();
    } else {
      open();
    }
  }, [opened, open, close]);

  return {
    opened,
    hasContent,
    open,
    close,
    toggle
  };
};

export default useCollapseState;
